import React from 'react';
import Translate from './Translate';

const MandatoryServiceSelected = () => (
  <Translate className="service__mandatory-marker" content="Mandatory" />
);

export default MandatoryServiceSelected;
